export { default as Variant1 } from '@/assets/graphics/accents/variant1.svg';
export { default as Variant2 } from '@/assets/graphics/accents/variant2.svg';
export { default as Variant3 } from '@/assets/graphics/accents/variant3.svg';
